export default "__VITE_ASSET__BjX8N37x__"